import { Action } from '@ngrx/store';
import { ClaimDocument, ClaimDocumentForm } from './claim-documents.models';
import { Parameter } from '@ecosure-suite/shared/utils-helpers';

export enum ClaimDocumentsActionTypes {
  LOAD_CLAIM_OWNER_DOCUMENTS = '[ClaimDocuments] Load Owner Claim Documents',
  LOAD_CLAIM_OWNER_DOCUMENTS_SUCCESS = '[ClaimDocuments] Load Owner Claim Documents Success',
  LOAD_CLAIM_OWNER_DOCUMENTS_FAIL = '[ClaimDocuments] Load Owner Claim Documents Fail',
  SAVE_CLAIM_DOCUMENT_INFORMATION = '[ClaimDocuments] Save Claim Document Information',
  UPDATE_CLAIM_DOCUMENT_INFORMATION = '[ClaimDocuments] Update Claim Document Information',
  SAVE_UPLOAD = '[ClaimDocuments] Save Upload Claim Document',
  SAVE_UPLOAD_SUCCESS = '[ClaimDocuments] Save Upload Claim Document Success',
  SAVE_UPLOAD_FAIL = '[ClaimDocuments] Save Upload Claim Document Fail',
  UPDATE_UPLOAD = '[ClaimDocuments] Update Upload Claim Document',
  UPDATE_UPLOAD_SUCCESS = '[ClaimDocuments] Update Upload Claim Document Success',
  UPDATE_UPLOAD_FAIL = '[ClaimDocuments] Update Upload Claim Document Fail'
}

export class LoadClaimOwnerDocuments implements Action {
  readonly type = ClaimDocumentsActionTypes.LOAD_CLAIM_OWNER_DOCUMENTS;
  constructor(public payload: Parameter) {}
}

export class LoadClaimOwnerDocumentsSuccess implements Action {
  readonly type = ClaimDocumentsActionTypes.LOAD_CLAIM_OWNER_DOCUMENTS_SUCCESS;
  constructor(public payload: ClaimDocument[]) {}
}

export class LoadClaimOwnerDocumentsFail implements Action {
  readonly type = ClaimDocumentsActionTypes.LOAD_CLAIM_OWNER_DOCUMENTS_FAIL;
  constructor(public payload: Error) {}
}
export class SaveClaimDocumentInformation implements Action {
  readonly type = ClaimDocumentsActionTypes.SAVE_CLAIM_DOCUMENT_INFORMATION;
  constructor(public payload: ClaimDocumentForm) {}
}

export class UpdateClaimDocumentInformation implements Action {
  readonly type = ClaimDocumentsActionTypes.UPDATE_CLAIM_DOCUMENT_INFORMATION;
  constructor(public payload: ClaimDocumentForm) {}
}

export class SaveUpload implements Action {
  readonly type = ClaimDocumentsActionTypes.SAVE_UPLOAD;
  constructor(public payload: ClaimDocumentForm) {}
}

export class SaveUploadSuccess implements Action {
  readonly type = ClaimDocumentsActionTypes.SAVE_UPLOAD_SUCCESS;
  constructor(public payload: ClaimDocument) {}
}

export class SaveUploadFail implements Action {
  readonly type = ClaimDocumentsActionTypes.SAVE_UPLOAD_FAIL;
  constructor(public payload: Error) {}
}

export class UpdateUpload implements Action {
  readonly type = ClaimDocumentsActionTypes.UPDATE_UPLOAD;
  constructor(public payload: ClaimDocumentForm) {}
}

export class UpdateUploadSuccess implements Action {
  readonly type = ClaimDocumentsActionTypes.UPDATE_UPLOAD_SUCCESS;
  constructor(public payload: ClaimDocument) {}
}

export class UpdateUploadFail implements Action {
  readonly type = ClaimDocumentsActionTypes.UPDATE_UPLOAD_FAIL;
  constructor(public payload: Error) {}
}

export type ClaimDocumentsAction =
  | LoadClaimOwnerDocuments
  | LoadClaimOwnerDocumentsSuccess
  | LoadClaimOwnerDocumentsFail
  | SaveClaimDocumentInformation
  | UpdateClaimDocumentInformation
  | SaveUpload
  | SaveUploadSuccess
  | SaveUploadFail
  | UpdateUpload
  | UpdateUploadSuccess
  | UpdateUploadFail;

export const fromClaimDocumentsActions = {
  LoadClaimOwnerDocuments,
  LoadClaimOwnerDocumentsSuccess,
  LoadClaimOwnerDocumentsFail,
  SaveClaimDocumentInformation,
  UpdateClaimDocumentInformation,
  SaveUpload,
  SaveUploadSuccess,
  SaveUploadFail,
  UpdateUpload,
  UpdateUploadSuccess,
  UpdateUploadFail
};
